

const overview = () => {
  if ($(".overview").length) {
    
  }
}

module.exports = overview
